import React, { FC, memo } from 'react';
import {
  CustomSelector,
  DropdownIndicatorArrow,
} from 'view/organisms/CustomSelector';
import { useTranslation } from 'react-i18next';
import {
  CustomDatePickerHeaderProps,
  Option,
} from './CustomDatePickerHeader.model';
import * as S from './CustomDatePickerHeader.styles';
import { useMonths } from '../../hooks/useMonths/useMonths.hook';
import { yearOptions } from '../../utils/utils';

const DropdownIndicator = DropdownIndicatorArrow();

export const CustomDatePickerHeader: FC<CustomDatePickerHeaderProps> = memo(
  ({ changeYear, changeMonth, date }) => {
    const { t } = useTranslation();

    const { months, monthOptions } = useMonths();

    const monthValue = monthOptions.find((_, i) => i === date?.getMonth());

    const yearValue = yearOptions.find(
      ({ value }) => value === String(date?.getFullYear()),
    );

    const handleMonthChange = (option: unknown) => {
      const selectedMonthIndex = months?.indexOf((option as Option).value);

      changeMonth(selectedMonthIndex ?? 0);
    };

    const handleYearChange = (option: unknown) => {
      changeYear(Number((option as Option).value));
    };

    return (
      <S.SelectorContainer>
        <CustomSelector
          value={monthValue}
          options={monthOptions}
          onChange={handleMonthChange}
          isSearchable={false}
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          className='month-selector'
          styles={{
            indicatorsContainer: (base) => ({
              ...base,
              padding: 0,
            }),
          }}
          placeholder={t(
            'discountEditor.step2.datePicker__monthSelectorPlaceholder',
          )}
          maxMenuHeight={300}
          isDatePickerSelector
        />

        <CustomSelector
          value={yearValue}
          options={yearOptions}
          onChange={handleYearChange}
          isSearchable={false}
          components={{
            DropdownIndicator,
            IndicatorSeparator: () => null,
          }}
          className='year-selector'
          styles={{
            indicatorsContainer: (base) => ({
              ...base,
              padding: 0,
            }),
          }}
          placeholder={t(
            'discountEditor.step2.datePicker__yearSelectorPlaceholder',
          )}
          maxMenuHeight={300}
          isDatePickerSelector
        />
      </S.SelectorContainer>
    );
  },
);
